import BlogPostContainer from "./BlogPostContainer";

const Korsika = () => {
    const blogPosts = [
        {
            date: "11.06.2026",
            title: "13. Tag",
            content: (
                <>
                    Hallo,
                    <br/><br/>
                    Heute sind wir nochmals in den Süden gefahren, damit wir die letzten zwei Nächte noch an einem
                    anderen Ort verbringen können.
                    <br/>
                    So sind wir wieder auf dem ersten Camping der Reise gelandet. Hier werden wir morgen nochmals einen Strandtag
                    verbringen.
                    <br/><br/>
                    Heute gibt es keine Bilder, da wir keine gemacht haben ;-)
                    <br/><br/>
                    Eure SüdwärtsFahrer
                </>
            ),
            images: [
                "/images/12_Korsika/13.1.jpeg",
            ]
        },
        {
            date: "10.06.2026",
            title: "12. Tag",
            content: (
                <>
                    Guten Abend liebe Leser,
                    <br/><br/>
                    Unser heutiger Tag:
                    <br/>
                    Camper - Strand - Meer - Strand - Camper - Strand - Meer - Strand - Camper - Duschen - Abendessen
                    - Schlafen.
                    <br/><br/>
                    Eure NichtsMacher
                </>
            ),
            images: [
                "/images/12_Korsika/12.1.jpeg",
            ]
        },
        {
            date: "09.06.2026",
            title: "11. Tag",
            content: (
                <>
                    Guten Abend liebe Leser,
                    <br/><br/>
                    Unser heutiger Tag:
                    <br/>
                    Camper - Strand - Meer - Strand - Camper - Strand - Meer - Strand - Meer - Camper - Duschen
                    - Spazieren - Abendessen - Glace - Spazieren - Schlafen.
                    <br/><br/>
                    Eure StrandLiegerUndMeerBaderUndGlaceGeniesser
                </>
            ),
            images: [
                "/images/12_Korsika/11.1.jpg",
                "/images/12_Korsika/11.2.jpeg",
            ]
        },
        {
            date: "08.06.2026",
            title: "10. Tag",
            content: (
                <>
                    Guten Abend,
                    <br/><br/>
                    Aufgrund einer Ameisenplage haben wir unseren Plan für einen entspannten Strandtag kurzerhand
                    über den Haufen geworfen und sind weitergezogen.
                    <br/><br/>
                    Immer weiter dem Cap entlang führte uns die Reise zunächst zum nördlichsten Punkt Korsikas.
                    Von dort aus ging es entlang der Westküste des Cap Corse wieder südwärts. Die Strecke
                    bot erneut wunderschöne Ausblicke auf das Meer, die Küste und die kleinen Dörfer entlang der Route.
                    <br/><br/>
                    Unterwegs machten wir einen Halt am Plage de Nonza. Der Strand ist für seine schwarzen
                    Steine bekannt, die sich dort aufgrund des ehemaligen Asbestabbaus in der Region angesammelt haben.
                    <br/><br/>
                    Anschließend ging es weiter nach Saint-Florent, wo wir nun auf einem Campingplatz stehen.
                    Nach unserer Ankunft haben wir den Strand genossen und uns etwas entspannt.
                    <br/><br/>
                    Nach dem Abendessen sind wir noch zu Fuß ins Dorf gelaufen. Dort haben wir uns eine feine Glace
                    gegönnt und den Tag gemütlich ausklingen lassen.
                    <br/><br/>
                    Eure AmeisenEntkommer
                </>
            ),
            images: [
                "/images/12_Korsika/10.1.jpeg",
                "/images/12_Korsika/10.2.jpeg",
                "/images/12_Korsika/10.3.jpeg",
                "/images/12_Korsika/10.4.jpeg",
                "/images/12_Korsika/10.5.jpg",
                "/images/12_Korsika/10.6.jpeg",
                "/images/12_Korsika/10.7.jpg",
            ]
        },
        {
            date: "07.06.2026",
            title: "9. Tag",
            content: (
                <>
                    Hallihallo,
                    <br/><br/>
                    Heute sind wir zum Cap Corse gefahren. Dafür folgten wir der Küste entlang nach Norden und
                    fuhren durch Bastia bis fast hinauf zur Spitze der Halbinsel.
                    <br/><br/>
                    Die Küstenstraße des Cap Corse ist wunderschön und führte uns vorbei an türkisfarbenen Buchten,
                    beeindruckenden Aussichten und vielen süßen, kleinen Dörfern.
                    <br/><br/>
                    Unterwegs musste der VW natürlich auch mal gewaschen werden...
                    <br/><br/>
                    Nach unserer Ankunft auf dem heutigen Campingplatz zog es uns natürlich direkt an den Strand.
                    Dort konnten wir das Meer und die Sonne genießen, bevor wir den Abend gemütlich ausklingen ließen.
                    <br/><br/>
                    Zu Fuß machten wir uns später noch auf den Weg in das nahegelegene Dorf, wo wir uns ein
                    feines Dessert gönnten.
                    <br/><br/>
                    Morgen werden wir hier noch einen weiteren entspannten Tag am Strand verbringen und die
                    wunderschöne Umgebung genießen.
                    <br/><br/>
                    Eure CapCorseEntdecker
                </>
            ),
            images: [
                "/images/12_Korsika/9.1.jpeg",
                "/images/12_Korsika/9.2.jpeg",
                "/images/12_Korsika/9.3.jpeg",
                "/images/12_Korsika/9.4.jpeg",
            ]
        },
        {
            date: "06.06.2026",
            title: "8. Tag",
            content: (
                <>
                    Guten Abend liebe Leser,
                    <br/><br/>
                    Unser heutiger Tag:
                    <br/>
                    Strand - Camper - Strand - Camper - Duschen - Abendessen - Spazieren - Schlafen.
                    <br/><br/>
                    Eure NichtsTuer
                </>
            ),
            images: [
                "/images/12_Korsika/7.1.jpeg",
            ]
        },
        {
            date: "05.06.2026",
            title: "7. Tag",
            content: (
                <>
                    Hallo und guten Abend,
                    <br/><br/>
                    Heute sind wir von Calvi über Corte nach Aléria gefahren. Doch beginnen wir von vorne:
                    <br/><br/>
                    In Calvi haben wir zunächst einen Intersport besucht, um uns besser gegen die unbarmherzige Sonne
                    zu schützen. Leider wurden wir dort nicht fündig, weshalb wir uns anschließend auf den Weg an
                    die Ostküste machten.
                    <br/><br/>
                    In Corte legten wir einen kurzen Halt ein – in der Hoffnung auf einen schönen Blick auf die
                    Zitadelle. Leider stellte sich heraus, dass dieser nur im Rahmen eines Museumsbesuchs möglich ist.
                    Deshalb ging unsere Reise schon bald weiter in Richtung Aléria.
                    <br/><br/>
                    Dort angekommen, haben wir zuerst unsere Vorräte aufgefüllt und konnten endlich einen lang
                    ersehnten Sonnenschirm ergattern. Danach hieß es: Campingplatz suchen! Nach kurzer Suche wurden
                    wir fündig und stehen nun auf einem einfachen, aber schön gelegenen Campingplatz direkt am Strand.
                    <br/><br/>
                    Den Rest des Nachmittags haben wir in der Sonne – und mittlerweile auch im Schatten unseres neuen
                    Sonnenschirms – verbracht. Nun lassen wir den Abend gemütlich ausklingen.
                    <br/><br/>
                    Hier werden wir sicher noch mindestens eine weitere Nacht bleiben. Deshalb wird es morgen
                    vermutlich nicht allzu viel Neues zu berichten geben.
                    <br/><br/>
                    Eure Schattensucher
                </>
            ),
            images: [
                "/images/12_Korsika/6.1.jpeg",
                "/images/12_Korsika/6.2.jpeg",
            ]
        },
        {
            date: "04.06.2026",
            title: "6. Tag",
            content: (
                <>
                    Guten Abend den Daheimgebliebenen
                    <br/><br/>
                    Heute führte uns die Fahrt weiter in Richtung der nordwestlichen Küste. Unser erstes Ziel war
                    Porto. Dort haben wir uns eine feine Glace gegönnt, während Sven die Bagger bei ihrer Arbeit im
                    Wasser beobachten konnte.
                    <br/><br/>
                    Anschließend ging es weiter nach Norden. Nach gefühlt 10.000 Kurven bergauf und bergab entdeckten
                    wir einen wunderschönen Strand mit dunklen, rund geschliffenen Kieselsteinen und einer
                    ordentlichen Brise Wind. Ein perfekter Ort für eine kleine Pause.
                    <br/><br/>
                    Danach setzten wir unsere Fahrt in Richtung Calvi fort. Nach unserer Ankunft machten wir uns zu
                    Fuss auf den Weg ins Städtchen und erkundeten die Gassen und die schöne Atmosphäre.
                    <br/><br/>
                    Nach einer feinen Pizza geht es nun zurück auf den Campingplatz, wo wir den Abend entspannt
                    ausklingen lassen.
                    <br/><br/>
                    Eure Kurvenfahrer
                </>
            ),
            images: [
                "/images/12_Korsika/5.1.jpg",
                "/images/12_Korsika/5.2.jpg",
                "/images/12_Korsika/5.3.jpg",
                "/images/12_Korsika/5.4.jpg",
                "/images/12_Korsika/5.5.jpg",
                "/images/12_Korsika/5.6.jpg",
                "/images/12_Korsika/5.7.jpg",
                "/images/12_Korsika/5.8.jpg",
                "/images/12_Korsika/5.9.jpg",
                "/images/12_Korsika/5.10.jpg",
                "/images/12_Korsika/5.11.jpg",
                "/images/12_Korsika/5.12.jpg",
                "/images/12_Korsika/5.13.jpg",
            ]
        },
        {
            date: "03.06.2026",
            title: "5. Tag",
            content: (
                <>
                    Hallo und herzlich Willkommen zu dem heutigen Tag
                    <br/><br/>
                    Heute sind wir von Zonza aus entlang der linken Seite der Bergkette in Richtung Corte gefahren.
                    Die Strecke war wunderschön – kurvenreich, abwechslungsreich und teilweise sehr eng. Dabei konnten
                    wir immer wieder beeindruckende Ausblicke auf die korsische Berglandschaft genießen.
                    <br/><br/>
                    Nachdem wir uns dazu entschieden haben,  Corte zu einem späteren Zeitpunkt zu besichtigen, ging es
                    weiter durch die beeindruckende Scala di Santa Regina.
                    Die spektakuläre Schlucht mit ihren steilen Felswänden und den kurvigen Straßen war definitiv
                    eines der Highlights des Tages.
                    <br/><br/>
                    Nun stehen wir auf einem Campingplatz inmitten dieser wunderschönen Landschaft und lassen den Tag
                    gemütlich ausklingen.
                    <br/><br/>
                    Morgen geht es weiter in Richtung der nordwestlichen Küste, wo wir wieder auf das Meer treffen werden.
                    <br/><br/>
                    Eure Schluchtenentdecker
                </>
            ),
            images: [
                "/images/12_Korsika/4.1.jpeg",
                "/images/12_Korsika/4.2.jpeg",
                "/images/12_Korsika/4.3.jpeg",
                "/images/12_Korsika/4.4.jpeg",
                "/images/12_Korsika/4.5.jpeg",
            ]
        },
        {
            date: "02.06.2026",
            title: "4. Tag",
            content: (
                <>
                    Guten Abend
                    <br/><br/>
                    Heute sind wir zunächst wieder in den Süden gefahren. Dort konnten wir Bonifacio von den
                    beeindruckenden Klippen aus bestaunen. Die Aussicht auf die Stadt und das Meer war wirklich
                    einzigartig.
                    <br/><br/>
                    Nachdem wir unseren Plan für die nächsten Tage festgelegt hatten, ging es wieder nordwärts. Dieses
                    Mal jedoch nicht der Küste entlang, sondern hinein in die Berge. Die nächsten zwei bis drei
                    Nächte werden wir im Inselinneren verbringen.
                    <br/><br/>
                    Nach einer abwechslungsreichen Fahrt über gute, holprige und teilweise sogar unbefestigte Straßen
                    haben wir unseren heutigen Übernachtungsplatz gefunden: einen Campingplatz direkt an einem Fluss.
                    <br/><br/>
                    Nach einem erfrischenden Sprung ins Wasser lassen wir den Abend nun gemütlich ausklingen.
                    <br/><br/>
                    Eure Flussschwimmenden
                </>
            ),
            images: [
                "/images/12_Korsika/3.1.jpeg",
                "/images/12_Korsika/3.2.jpeg",
                "/images/12_Korsika/3.3.jpeg",
                "/images/12_Korsika/3.4.jpg",
                "/images/12_Korsika/3.5.jpeg",
                "/images/12_Korsika/3.6.jpeg",
            ]
        },
        {
            date: "01.06.2026",
            title: "3. Tag",
            content: (
                <>
                    Hallihallo!
                    <br/><br/>
                    Heute haben wir es ganz entspannt angehen lassen. Nach einem feinen Frühstück ging es
                    direkt an den Strand, wo wir das schöne Wetter und das Meer genossen haben.
                    <br/><br/>
                    Nach dem Abendessen machten wir noch einen Spaziergang am Strand entlang und ließen
                    den Tag gemütlich ausklingen.
                    <br/><br/>
                    Das war's auch schon für heute.
                    <br/>
                    Bis morgen!
                    <br/><br/>
                    Eure inDerSonneLiegenden
                </>
            ),
            images: [
                "/images/12_Korsika/2.1.jpg",
                "/images/12_Korsika/2.2.jpeg",
            ]
        },
        {
            date: "30. & 31.05.2026",
            title: "1. & 2. Tag",
            content: (
                <>
                    Hallo zusammen und herzlich willkommen zu einer neuen Reise!
                    <br/><br/>
                    Am 30.05. ging es früh morgens in Richtung Toulon zur Fähre nach Korsika. Die Anreise haben
                    wir aufgeteilt, sodass wir bereits um 16:00 Uhr am Hafen waren. Sven konnte sich in der
                    Zwischenzeit das Spiel Schweiz gegen Norwegen anschauen, während wir auf die Einschiffung gewartet haben.
                    <br/> <br/>
                    Nachdem wir unsere Kabine bezogen und die Abfahrt verfolgt hatten, ging es zum Abendessen ins Burger-Restaurant.
                    <br/><br/>
                    NNach einer kurzen Nacht konnten wir um 06:00 Uhr den Sonnenaufgang über Korsika
                    bestaunen, bevor wir nach dem Anlegen weiter in den Süden fuhren. Unterwegs mussten wir natürlich
                    an einem wunderschönen Strand anhalten, damit die Füße endlich ins Meer konnten.
                    <br/><br/>
                    Danach sind wir zum Camping California gefahren, auf dem wir die nächsten zwei Nächte
                    verbringen werden. <br/>
                    Hier haben wir das schöne Wetter und das Meer genossen, bevor es nun bald Abendessen gibt.
                    <br/><br/>
                    Damit endet unser erster Tag auf Korsika. Bis morgen!
                    <br/><br/>
                    Eure Reisestartenden
                </>
            ),
            images: [
                "/images/12_Korsika/1.1.jpg",
                "/images/12_Korsika/1.2.jpg",
                "/images/12_Korsika/1.3.jpg",
                "/images/12_Korsika/1.4.jpg",
                "/images/12_Korsika/1.5.jpg",
                "/images/12_Korsika/1.6.jpg",
                "/images/12_Korsika/1.7.jpg",
            ]
        },
    ];
    return (
        <div className="container my-5">
            <div>
                <h2 className="Blog_Title">Korsika</h2>
            </div>
            {blogPosts.map((post, index) => (
                <BlogPostContainer
                    index={index}
                    title={post.title}
                    date={post.date}
                    content={post.content}
                    images={post.images}
                />
            ))}
        </div>
    );
}
export default Korsika;